import { CancelToken } from 'axios';
import ApiProvider from '../../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../../core/types/ActionStatusType';
import { DictionaryType } from '../../../../core/types/DictionaryType';

const UserProfileApi = {
  ChangeUserLanguage: async (languageCode: string, cancelToken: CancelToken) => {
    return await ApiProvider.get<ActionStatusType>(
      `UserProfileModule/ChangeUserLanguage/${languageCode}`,
      cancelToken
    );
  },
  ChangeAccountSettings: async (fromValues: DictionaryType<string>, cancelToken: CancelToken) => {
    return await ApiProvider.post<ActionStatusType>(
      'UserProfileModule/ChangeAccountSettings',
      fromValues,
      cancelToken
    );
  },
};

export default UserProfileApi;
